import { createSlice } from "@reduxjs/toolkit";
import { getPurchaseOrder } from "../../reduxApi/admin/PurchaseOrderReduxApi";
import { addPurchaseOder } from "../../api/admin/PurchaseOrderApi";

const PurchaseOderSlice = createSlice({
  name: "PurchaseOders",
  initialState: {
    status: "idle",
    PurchaseOders: [],
    addPurchaseOders: [],
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPurchaseOrder.pending, (state) => {
        state.status = "pending";
        console.log("state.PurchaseOders", state.PurchaseOders);
      })
      .addCase(getPurchaseOrder.fulfilled, (state, action) => {
        state.status = "fulfilled";
        state.PurchaseOders = action.payload.purchaseOrder;
        console.log("state.PurchaseOders", state.PurchaseOders);
      });
    // .addCase(addPurchaseOder.fulfilled, (state, action) => {
    //   state.status = "fulfilled";
    //   state.addPurchaseOders = action.payload.data;
    //   console.log("state.addPurchaseOders", state.addPurchaseOders);
    // });
  },
});

export default PurchaseOderSlice.reducer;
